import serverInterface from 'server-interface';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

class PageEventDefinitions {

  constructor() {

    this.initialized = false;
    this.collection = [];

  }

  async initialize() {

    this.registerEventHandlers();

    await this.loadAll();

    this.initialized = true;

  }

  tryAdd(object) {

    const objectIndex = findIndexByPropertyValue(this.collection, '_id', object._id);

    if (objectIndex !== -1) {
      return;
    }

    this.collection.push(object);

  }

  tryRemoveObject(objectId) {

    const objectIndex = findIndexByPropertyValue(this.collection, '_id', objectId);

    if (objectIndex === -1) {
      return;
    }

    this.collection.splice(objectIndex, 1);

  }

  handleObjectCreatedEvent(payload) {

    this.tryAdd(payload.object);

  }

  handleObjectDeletedEvent(payload) {

    this.tryRemoveObject(payload.objectId);

  }

  formatDefinitions(collection) {

    for (let object of collection) {

      const type = object.type;

      if (type === 'Click') {
        object.name = 'Total Clicks';
      } else if (type === 'Signup') {
        object.name = 'Registered Users';
      } else if (type === 'Paid User') {
        object.name = 'Paid Users';
      } else if (type === 'PAGE_VIEW') {
        object.name = 'Total Views';
      } else {
        object.name = type;
      }

    }

    return collection;

  }

  registerEventHandlers() {}

  async loadAll() {

    this.collection = await serverInterface.startup.analytics.getPageEventDefinitions();

    this.collection = this.formatDefinitions(this.collection);

  }

  setAll(collection) {

    this.collection = this.formatDefinitions(collection);

  }

  getAll() {

    return this.collection;

  }

  isObjectExistsById(objectId) {

    const objectIndex = findIndexByPropertyValue(this.collection, '_id', objectId);

    return objectIndex !== -1;

  }

  getByType(type) {

    const objectIndex = findIndexByPropertyValue(this.collection, 'type', type);

    return this.collection[objectIndex] || null;

  }

  async create(data) {

    const object = await serverInterface.startup.analytics.createPageEventDefinition(data);

    this.tryAdd(this.formatDefinitions([object])[0]);

    return object;

  }

  async setHidden(objectId, hidden) {

    await serverInterface.startup.analytics.hidePageEventDefinition(objectId, hidden);

    const objectIndex = findIndexByPropertyValue(this.collection, '_id', objectId);

    this.collection[objectIndex].hidden = hidden;

  }

  hasHiddenDefinitions() {

    const objectIndex = findIndexByPropertyValue(this.collection, 'hidden', true);

    return objectIndex !== -1;

  }

  async delete(objectId) {

    await serverInterface.startup.analytics.deletePageEventDefinition(objectId);

    this.tryRemoveObject(objectId);

  }

}

export default PageEventDefinitions;